import { Box, NumberInput, NumberInputField } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useState } from 'react';

import { Condition } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import formatCurrency from 'Helper/formatCurrency';

import styles from './styles.module.css';

const InputCurrency = ({
  label,
  isRequired,
  placeholder,
  value,
  onChange,
  margin,
  className,
  error,
  height,
  rightLabel,
  rightLabelPosition = 'space-between',
}) => {
  const isError = !isEmpty(error);
  const [internalValue, setInternalValue] = useState(value);

  const handleChange = (eventValue) => {
    if (parseInt(eventValue) === Number.MIN_SAFE_INTEGER) return;

    if (eventValue && parseInt(eventValue) > 0) {
      if (eventValue.charAt(0) === '0') {
        eventValue.slice(1, eventValue.length - 1);
      }
      const intValue = parseInt(eventValue.replaceAll('.', ''));
      setInternalValue(intValue);
      onChange(intValue);
    } else {
      setInternalValue(0);
      onChange(0);
    }
  };

  return (
    <Box margin={margin} className={`${className} ${styles['input-currency-container']}`}>
      <Condition statement={label}>
        <Box className={styles['label__container']} justifyContent={rightLabelPosition}>
          <TextSemiBold className={styles['text__title']}>
            {label}{' '}
            <Condition statement={isRequired}>
              <span>*</span>
            </Condition>
          </TextSemiBold>
          <Condition statement={rightLabel}>
            <Box className={styles['box__right-label']}>{rightLabel}</Box>
          </Condition>
        </Box>
      </Condition>
      <Box position="relative">
        <Box className={styles['input-currency-overlay']}>Rp</Box>
        <NumberInput value={internalValue ? formatCurrency(internalValue, false) : ''} onChange={handleChange}>
          <NumberInputField
            placeholder={placeholder}
            className={styles['input-currency__box-input']}
            height={height}
            background={internalValue ? 'white' : 'var(--color-semantic-background)'}
          />
        </NumberInput>
      </Box>

      <Condition statement={isError}>
        <TextRegular className={styles['error__text']}>{error?.message}</TextRegular>
      </Condition>
    </Box>
  );
};

export default InputCurrency;
